import { LitEntity, html } from '../../utility/lit-entity';

class WorkOrderCount extends LitEntity {
  render() {
    return html`${this.totalCount}`;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.totalCount = this.getProperty('totalCount');
  }
}

customElements.define('work-order-count', WorkOrderCount);
